export const USER_TYPE_USER = 'USER_TYPE_USER';
export const USER_TYPE_ADMINISTRATION = 'USER_TYPE_ADMINISTRATION';
export const EVENT_NAME_PASSWORD_INPUT = 'PASSWORD:INPUT';
export const EVENT_PASSWORD_INPUT = new CustomEvent(EVENT_NAME_PASSWORD_INPUT);
export const EVENT_NAME_STEP_VALIDATE = 'STEP:VALIDATE';
export const EVENT_NAME_FIELDS_VALIDATE = 'FIELDS:VALIDATE';
export const EVENT_STEP_VALIDATE = new CustomEvent(EVENT_NAME_STEP_VALIDATE, {
    bubbles: true,
    cancelable: true,
});
export const EVENT_NAME_CLOSE_RECEIPT = 'CLOSE:RECEIPT';
export const EVENT_CLOSE_RECEIPT = new CustomEvent(EVENT_NAME_CLOSE_RECEIPT);
export const PAY_PER_USE = __('Pay per use');
// Credit card types
export const PAYMENT_TYPE_SEPA = 'sepa';
export const PAYMENT_TYPE_CREDIT_CARD = 'creditcard';
export const CREDIT_CARD_TYPE_MASTERCARD = 'mastercard';
export const CREDIT_CARD_TYPE_VISA = 'visa';
export const DOCUMENT_POSITION_FOLLOWING = 4;
export const DOCUMENT_POSITION_PRECEDING = 2;
// COUNTRIES
export const COUNTRY_NETHERLANDS = 'NL';
export const COUNTRY_BELGIUM = 'BE';
export const COUNTRY_FRANCE = 'FR';
// Postal code modes
export const POSTAL_CODE_NL = 'NL';
export const POSTAL_CODE_BE = 'BE';
export const POSTAL_CODE_OTHER = 'ZZ';

// Flag to use URL values
export const URL_FLAG = 'utm_campaign';
export const URL_FLAG_VALUE = 'abandoned_cart';

// Customer types
export const NEW_CUSTOMER = 'new-customer';
export const EXISTING_CUSTOMER = 'existing-customer';

// Wizard types
export const WIZARD_FR_BE = 'fr-BE';
export const WIZARD_NL_BE = 'nl-BE';

// VAT
export const VAT_RATE_NL = 0.21;
export const VAT_SETTINGS = {
    'NL': 21,
    'BE': 21,
};

export const VAT_VALIDATION_SETTINGS = {
    'AT': {
        placeholder: 'U99999999',
        regex: /^(AT)?U[0-9]{8}$/i,
    },
    'BE': {
        placeholder: '0999999999',
        regex: /(^(BE)?[01][0-9]{9}$)|^BENONVAT$|^LUNONVAT$|^BEREQ$|^LUREQ$/i,
    },
    'BG': {
        placeholder: '(9)999999999',
        regex: /^(BG)?[0-9]{9,10}$/i,
    },
    'CY': {
        placeholder: '99999999L',
        regex: /^(CY)?[0-9]{8}L$/i,
    },
    'CZ': {
        placeholder: '(99)99999999',
        regex: /^(CZ)?[0-9]{8,10}$/i,
    },
    'DE': {
        placeholder: '999999999',
        regex: /^(DE)?[0-9]{9}$/i,
    },
    'DK': {
        placeholder: '99999999',
        regex: /^(DK)?[0-9]{8}$/i,
    },
    'EE': {
        placeholder: '999999999',
        regex: /^(EE)?[0-9]{9}$/i,
    },
    'GR': {
        placeholder: '999999999',
        regex: /^(EL|GR)?[0-9]{9}$/i,
    },
    'ES': {
        placeholder: 'X9999999X',
        regex: /^(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]$/i,
    },
    'FI': {
        placeholder: '99999999',
        regex: /^(FI)?[0-9]{8}$/i,
    },
    'FR': {
        placeholder: 'XX999999999',
        regex: /^(FR)?[0-9A-Z]{2}[0-9]{9}$/i,
    },
    'GB': {
        placeholder: '(999)999999999',
        regex: /^(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})$/i,
    },
    'HU': {
        placeholder: '99999999',
        regex: /^(HU)?[0-9]{8}$/i,
    },
    'IE': {
        placeholder: '9S99999L',
        regex: /^(IE)?[0-9]S[0-9]{5}L$/i,
    },
    'IT': {
        placeholder: '99999999999',
        regex: /^(IT)?[0-9]{11}$/i,
    },
    'LT': {
        placeholder: '(99)999999999',
        regex: /^(LT)?([0-9]{9}|[0-9]{12})$/i,
    },
    'LU': {
        placeholder: '99999999',
        regex: /^(LU)?[0-9]{8}$/i,
    },
    'LV': {
        placeholder: '99999999999',
        regex: /^(LV)?[0-9]{11}$/i,
    },
    'MT': {
        placeholder: '99999999',
        regex: /^(MT)?[0-9]{8}$/i,
    },
    'NL': {
        placeholder: '999999999B99',
        regex: /^(NL)?[0-9]{9}B[0-9]{2}$/i,
    },
    'PL': {
        placeholder: '999999999',
        regex: /^(PL)?[0-9]{10}$/i,
    },
    'PT': {
        placeholder: '999999999',
        regex: /^(PT)?[0-9]{9}$/i,
    },
    'RO': {
        placeholder: '(9999999)999',
        regex: /^(RO)?[0-9]{2,10}$/i,
    },
    'SE': {
        placeholder: '99999999999',
        regex: /^(SE)?[0-9]{12}$/i,
    },
    'SI': {
        placeholder: '99999999',
        regex: /^(SE)?[0-9]{12}$/i,
    },
    'SK': {
        placeholder: '999999999',
        regex: /^(SK)?[0-9]{10}$/i,
    },
};
